/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightDownIcon20Regular = forwardRef('ArrowDUturnRightDownIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M15.75 9a6.75 6.75 0 0 0-13.5 0v4.25a.75.75 0 0 0 1.5 0V9a5.25 5.25 0 1 1 10.5 0v5.96l-2.929-3.446a.75.75 0 0 0-1.143.972l3.298 3.88a2 2 0 0 0 3.048 0l3.297-3.88a.75.75 0 0 0-1.143-.972L15.75 14.96V9Z" })));
});
